var _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7, _circle2, _path8, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgNotificationsError = function SvgNotificationsError(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 150 154",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 75,
    cy: 79,
    r: 75,
    fill: "#FAFBFF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M97.254 27.39c-1.444 5.387-6.982 8.585-12.37 7.141-5.388-1.444-8.585-6.982-7.142-12.37 1.444-5.388 6.982-8.585 12.37-7.141C95.5 16.463 98.698 22 97.254 27.39Z",
    fill: "url(#notificationsError_svg__a)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M39.958 54.039c-4.823 12.708-8.851 20.135-18.379 24.937l92.804 22.386c-2.961-9.123-2.922-16.113-.062-30.854 2.99-15.415-1.471-38.497-26.356-45.165-31.913-8.55-43.184 15.987-48.007 28.696Z",
    fill: "url(#notificationsError_svg__b)"
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.735 85.768c.151-.578.306-1.186.468-1.823.81-3.185 1.805-7.094 3.462-11.613.696-1.897 1.37-3.88 2.061-5.911C59.944 54.024 64.79 39.783 78.91 31.69l-2.686-3.201c-5.11.55-16.865 4.537-23.005 16.077-2.608 4.9-4.54 10.106-6.538 15.485-2.704 7.284-5.527 14.889-10.307 22.494l13.361 3.223Z",
    fill: "url(#notificationsError_svg__c)",
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M107.844 38.251c-5.924-2.056-11.702.566-12.84 8.119-.612 4.048-1.279 8.144-1.942 12.215-1.443 8.863-2.868 17.615-3.656 25.54-.511 5.142-.108 8.859.547 11.345l24.43 5.892c-2.961-9.122-2.922-16.112-.063-30.853 1.885-9.717.81-22.48-6.476-32.258Z",
    fill: "url(#notificationsError_svg__d)",
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.3
  }), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M59.99 127.105c30.912 8.283 57.935 7.669 60.358-1.372l3.057-11.409c.531-1.984 4.829-18.023-51.142-33.02-55.972-14.998-60.27 1.04-60.8 3.025l-3.058 11.41c-2.422 9.04 20.673 23.083 51.585 31.366Z",
    fill: "url(#notificationsError_svg__e)"
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.272 93.223c1.046.097 1.922.18 2.571.225 3.873.272 4.755-3.193 6.36-9.503.531-2.085 1.141-4.48 1.963-7.153-14.745-2.546-24.13-2.135-30.115-.612-2.35 5.058-4.394 10.963-5.86 18.277 5.7-3.05 18.62-1.84 25.081-1.234Z",
    fill: "url(#notificationsError_svg__f)",
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M123.46 114.111c-3.435-6.268-9.103-11.272-15.08-15.064-9.771-6.199-21.453.612-24.447 11.789l25.637 13.782 12.136-3.955 1.699-6.339c.016-.059.035-.13.055-.213Z",
    fill: "url(#notificationsError_svg__g)",
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.5
  }), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M111.175 124.25c-1.334 4.977-23.476 3.368-49.457-3.593-25.98-6.962-45.961-16.64-44.628-21.617 1.334-4.977 23.476-3.368 49.457 3.594 25.981 6.961 45.962 16.639 44.628 21.616Z",
    fill: "url(#notificationsError_svg__h)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M78.762 119.553a16.077 16.077 0 0 1-2.06 4.627c-4.751-.954-9.79-2.132-14.983-3.523a243.189 243.189 0 0 1-14.571-4.385c-.09-1.657.075-3.358.528-5.049 1.384-5.163 5.127-9.063 9.759-10.852 2.964.677 6.011 1.432 9.113 2.263 3.164.847 6.239 1.735 9.197 2.65 3.111 3.864 4.4 9.11 3.017 14.269Z",
    fill: "url(#notificationsError_svg__i)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M61.719 120.657a243.462 243.462 0 0 0 14.983 3.523c-3.699 5.674-10.75 8.599-17.647 6.751-6.893-1.847-11.536-7.9-11.907-14.659 4.544 1.53 9.44 3.01 14.57 4.385Z",
    fill: "url(#notificationsError_svg__j)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M72.786 120.981c.888 2.402-1.375 5.453-5.055 6.814-3.68 1.36-7.383.515-8.272-1.887-.888-2.403 1.375-5.454 5.055-6.814 3.68-1.361 7.384-.516 8.272 1.887Z",
    fill: "#fff"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 123.5,
    cy: 46.5,
    r: 21.5,
    fill: "#E37570"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M126.83 51.316h-5.567L120.094 29H128l-1.17 22.316ZM120 59.129c0-1.435.39-2.433 1.17-2.994.779-.593 1.731-.89 2.853-.89 1.092 0 2.028.297 2.807.89.78.56 1.17 1.559 1.17 2.994 0 1.372-.39 2.37-1.17 2.994-.779.592-1.715.889-2.807.889-1.122 0-2.074-.297-2.853-.89-.78-.623-1.17-1.621-1.17-2.993Z",
    fill: "#fff"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "notificationsError_svg__a",
    x1: 91.448,
    y1: 9.703,
    x2: 84.76,
    y2: 34.663,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ECF1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CCD9F9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "notificationsError_svg__b",
    x1: 85.526,
    y1: 24.69,
    x2: 67.671,
    y2: 91.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F0F4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D2DFFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "notificationsError_svg__c",
    x1: 86.51,
    y1: 19.295,
    x2: 49.938,
    y2: 86.062,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFCFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D7DFF5",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "notificationsError_svg__d",
    x1: 113.77,
    y1: 39.803,
    x2: 98.258,
    y2: 97.695,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9FBFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7F9FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "notificationsError_svg__e",
    x1: 72.263,
    y1: 81.303,
    x2: 59.99,
    y2: 127.105,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E2EAFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AFC7FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "notificationsError_svg__f",
    x1: 51.354,
    y1: 87.574,
    x2: 26.064,
    y2: 87.71,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EFF3FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAFBFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "notificationsError_svg__g",
    x1: 86.251,
    y1: 102.184,
    x2: 114.945,
    y2: 113.593,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9FBFF",
    stopOpacity: 0.69
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF1FE",
    stopOpacity: 0.07
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "notificationsError_svg__h",
    x1: 66.547,
    y1: 102.634,
    x2: 61.656,
    y2: 120.889,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7190E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#89A8F8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "notificationsError_svg__i",
    x1: 70.236,
    y1: 88.87,
    x2: 58.922,
    y2: 131.093,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#94B4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CBD7FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "notificationsError_svg__j",
    x1: 70.236,
    y1: 88.87,
    x2: 58.922,
    y2: 131.093,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#94B4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CBD7FF"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgNotificationsError);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "assets/notificationsError.svg";